import React, { useEffect, useRef } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { gsap, Power2 } from 'gsap'

import withMemo from '../../decorators/withMemo'
import Image from '../Image'

import useStyles from './styles'


const LookGrid = (props) => {
  const classes = useStyles(props)
  const {
    className,
    lookClassName,
    looks,
    onLookClick,
  } = props

  // animations
  const $animatedWrapper = useRef()

  useEffect(() => {
    const timeline = gsap.timeline({ delay: 0.1 })

    if ($animatedWrapper.current) {
      const animatedChildren = Array
        .from($animatedWrapper.current.querySelectorAll('.is-staggered'))
        .filter((child) => !child.classList.contains('is-notstaggered'))

      timeline.fromTo(animatedChildren, {
        opacity: 0,
      }, {
        duration: 0.55,
        opacity: 1,
        stagger: 0.06,
        ease: Power2.easeIn,
      })
    }
  }, [classes.image])

  return (
    <div className={cx(className, classes.container)}>
      <div
        className={classes.wrapper}
        ref={$animatedWrapper}
      >
        {looks.map((look, index) => (
          <div
            className={cx(classes.look, lookClassName)}
            key={look.id}
            onClick={() => {
              onLookClick({ index, id: look.id, title: look.title })
            }}
          >
            {look.fluid && (
              <Image
                img={look.fluid}
                className={cx(classes.image, 'is-staggered')}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

LookGrid.propTypes = {
  className: PropTypes.string,
  lookClassName: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  looks: PropTypes.any,
  onLookClick: PropTypes.func,
}

LookGrid.defaultProps = {
  className: null,
  lookClassName: null,
  looks: [],
  onLookClick: () => {},
}

export default withMemo()(LookGrid)
